export default "__VITE_ASSET__KKP2c97P__"